import { IIconBase } from '..'

const mapaIcon = ({
  color = '#000000',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      version='1.0'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M2430 5114 c-229 -26 -360 -54 -508 -109 -392 -147 -720 -416 -943
        -775 -210 -339 -307 -778 -259 -1170 78 -631 528 -1501 1274 -2465 176 -228
        403 -501 455 -548 69 -62 153 -62 222 0 52 47 279 320 455 548 671 867 1102
        1655 1238 2267 35 157 46 259 46 423 -1 480 -193 939 -540 1285 -286 287 -623
        460 -1020 525 -94 15 -352 27 -420 19z m340 -345 c354 -47 688 -227 927 -499
        311 -353 441 -822 354 -1275 -91 -475 -383 -1065 -866 -1754 -208 -297 -604
        -811 -625 -811 -21 0 -417 514 -625 811 -483 689 -775 1279 -866 1754 -122
        633 185 1280 760 1603 272 152 617 215 941 171z'
        />
        <path
          d='M2415 4185 c-105 -17 -173 -39 -271 -87 -225 -109 -414 -338 -484
        -588 -27 -95 -37 -286 -21 -390 47 -296 241 -556 516 -690 162 -79 328 -109
        498 -90 131 15 198 34 312 90 275 134 469 394 516 690 16 104 6 295 -21 390
        -69 248 -260 479 -484 588 -184 90 -369 118 -561 87z m339 -353 c147 -53 270
        -161 336 -295 66 -134 84 -257 55 -390 -36 -173 -151 -327 -305 -411 -69 -38
        -190 -66 -280 -66 -90 0 -211 28 -280 66 -189 103 -320 319 -320 529 0 120 54
        271 132 372 72 94 204 179 323 210 78 20 266 11 339 -15z'
        />
      </g>
    </svg>
  )
}

export default mapaIcon
